import { Box, Typography } from "@mui/material";

// Custom component for the "No Rows" overlay
const CustomNoRowsOverlay = () => {
	return (
		<Box
			sx={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				height: '100%'
			}}
		>
			<Typography>No tasks available</Typography>
		</Box>
	);
};

export default CustomNoRowsOverlay